import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { MessagesError, MessagesNoResults } from "components/Messages";
import { Spinner } from "components/Loader";
import ApplicantInterviewRequestCard from "./ApplicantInterviewRequestCard";

/**
 * ApplicantInterviewRequests
 *
 * Every interview request sent to an applicant, newest first.
 *
 * @param {Array}   requests  Interview scheduling requests
 * @param {Boolean} loading   Whether the requests are loading
 * @param {Object}  error     Error from loading the requests
 */
const ApplicantInterviewRequests = ({ requests, loading, error, ...props }) => {
  if (loading) return <Spinner size="2rem" margin="2rem auto" />;
  if (error) return <MessagesError />;

  if (requests.length === 0) {
    return (
      <MessagesNoResults
        title="Missions.Applicants.InterviewModal.Requests.EmptyTitle"
        description="Missions.Applicants.InterviewModal.Requests.EmptyDescription"
      />
    );
  }

  return (
    <ul css={styles.list} {...props}>
      {requests.map((request) => (
        <li key={request.id}>
          <ApplicantInterviewRequestCard request={request} />
        </li>
      ))}
    </ul>
  );
};

const styles = {
  list: css`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    margin: 0;
    padding: 0;
    list-style: none;

    > li {
      margin: 0;
    }
  `,
};

ApplicantInterviewRequests.propTypes = {
  requests: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
};

export default ApplicantInterviewRequests;
